export default [
    {
        path: '/heishop/bonificaciones',
        name: 'heishop-bonificaciones',
        meta: {
            layout: 'session'
        },
        component: () => import('VIEWS/heishop/Bonificaciones.vue')
    },

]